import React, { useState } from 'react';
import { Card } from './ui/card';
import { Heart, MessageCircle, Play } from 'lucide-react';
import { contentShowcase } from '../data/mock';

const ContentShowcase = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section id="content" className="bg-[#0B0B0B] py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF3B3B] text-sm font-semibold uppercase tracking-widest mb-4 block">
            Content Portfolio
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Content That Converts
          </h2>
          <p className="text-[#9CA3AF] text-lg max-w-2xl mx-auto">
            High-quality fitness content that engages millions and drives action.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {contentShowcase.map((item, index) => (
            <Card
              key={item.id}
              className={`relative overflow-hidden rounded-2xl border-0 group cursor-pointer animate-fadeInUp`}
              style={{ animationDelay: `${index * 100}ms` }}
              onMouseEnter={() => setHoveredId(item.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="aspect-square relative overflow-hidden">
                <img
                  src={item.image}
                  alt={`Content ${item.id}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                
                {/* Overlay */}
                <div
                  className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-300 ${
                    hoveredId === item.id ? 'opacity-100' : 'opacity-0'
                  }`}
                />

                {/* Reel Badge */}
                {item.type === 'reel' && (
                  <div className="absolute top-3 right-3 bg-white/20 backdrop-blur-sm rounded-full p-2">
                    <Play size={16} className="text-white" fill="white" />
                  </div>
                )}

                {/* Hover Content */}
                <div
                  className={`absolute bottom-0 left-0 right-0 p-4 transition-all duration-300 ${
                    hoveredId === item.id ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1.5">
                      <Heart size={18} className="text-[#FF3B3B]" fill="#FF3B3B" />
                      <span className="text-white font-semibold text-sm">{item.likes}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <MessageCircle size={18} className="text-white" />
                      <span className="text-white font-semibold text-sm">{item.comments}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* View More Link */}
        <div className="text-center mt-12">
          <a
            href="#"
            className="inline-flex items-center gap-2 text-[#FF3B3B] hover:text-[#E02F2F] font-semibold transition-colors duration-300"
          >
            View Full Portfolio
            <span className="text-xl">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContentShowcase;
